var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit3SvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.524,
    height: 15.499,
    viewBox: "0 0 15.524 15.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-3-svgrepo-com",
    transform: "translate(-1.25 -1.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M16.965,5.04l-6.649,6.649c-.662.662-2.627.969-3.067.53s-.139-2.4.523-3.067L14.428,2.5A1.8,1.8,0,1,1,16.965,5.04Z",
    transform: "translate(-1.528)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M8.272,4H4.788A2.788,2.788,0,0,0,2,6.788v6.969a2.788,2.788,0,0,0,2.788,2.788h7.666c1.54,0,2.091-1.254,2.091-2.788V10.272",
    transform: "translate(0 -0.632)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit3SvgrepoCom);
export default __webpack_public_path__ + "static/media/edit-3-svgrepo-com.314d1656f00b950d109ab09561c6ba28.svg";
export { ForwardRef as ReactComponent };